import { render, staticRenderFns } from "./ImoFalForm6MenuGrid.vue?vue&type=template&id=2a38558e"
import script from "./ImoFalForm6MenuGrid.vue?vue&type=script&lang=js"
export * from "./ImoFalForm6MenuGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports